import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const Progress = ({ skills }) => {
    return (
        <div className='w-full flex justify-around align-center flex-wrap bg-gray-800 subheadings-font'>
            {skills.map((skill, index) => {
                return (
                    <>
                        <div className='hidden md:block m-4 md:mx-4 px-2' key={index} style={{ width: '200px', height: '200px' }}>
                            <CircularProgressbar
                                value={skill?.percentage}
                                text={skill?.name}
                                background
                                backgroundPadding={6}
                                styles={buildStyles({
                                    textSize: '12px',
                                    pathTransitionDuration: 0.5,
                                    backgroundColor: "#3e98c7",
                                    textColor: "#fff",
                                    pathColor: "#fff",
                                    trailColor: "transparent"
                                })}
                            />
                        </div>
                        <div className='block md:hidden m-4 md:mx-4 px-2' key={index} style={{ width: '130px', height: '130px' }}>
                            <CircularProgressbar
                                value={skill?.percentage}
                                text={skill?.name}
                                background
                                backgroundPadding={6}
                                styles={buildStyles({
                                    textSize: '12px',
                                    pathTransitionDuration: 0.5,
                                    backgroundColor: "#3e98c7",
                                    textColor: "#fff",
                                    pathColor: "#fff",
                                    trailColor: "transparent"
                                })}
                            />
                        </div>
                    </>
                )
            })}
        </div>
    )
}

export default Progress
